import { render, staticRenderFns } from "./ChatOrderListPanel.vue?vue&type=template&id=3c0ac8b3&scoped=true&"
import script from "./ChatOrderListPanel.vue?vue&type=script&lang=js&"
export * from "./ChatOrderListPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderListPanel.vue?vue&type=style&index=0&id=3c0ac8b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ac8b3",
  null
  
)

export default component.exports